// Shortlist.tsx
import { useEffect, useState } from "react";
import axios from "axios";
import CollegeCard from "./CollegeCard";
import config from "../../../util/config";
import {BaseURL, BaseURLAuth} from "../../../services/api";
interface IWishlist {
  image: string;
  title: string;
  category: string;
  collegeId: number;
  location: string;
}

const Shortlist = () => {
  // const [shortListData, setShortListData] = useState<IShortlist[]>([]);
  // const [userId, setUserId] = useState<string | null>(null);

  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     const parsedUser = JSON.parse(storedUser);
  //     setUserId(parsedUser.userId);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (userId) {
  //     axios({
  //       url: `${config.apiUrl}/api/admissions/shortlisted/${userId}`,
  //       // url: `${config.apiUrl}/api/wishlist/category/${userId}?category=college`,

  //       method: "GET",
  //     })
  //       .then((response) => {
  //         setShortListData(response.data.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching mentor data:", error);
  //       });
  //   } else {
  //     console.log("userId is null, skipping API call");
  //   }
  // }, [userId]);
  const [wishlistData, setWishlistData] = useState<IWishlist[]>([]);

  const fetchWishlistData = () => {
    const user = localStorage.getItem("user");
    if (!user) {
      return;
    }

    getUserWishList();
  };

  function getUserWishList() {
    const userId = JSON.parse(localStorage.getItem("user") ?? "{}")?.userId;
    if (userId) {
      const accessToken = localStorage.getItem("accessToken");
      BaseURL.get(`/api/wishlist/category/${userId}?category=college`, {
        headers: {
          Authorization: accessToken ? `${accessToken}` : "",
        },
      })
        .then((response) => {
          setWishlistData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching wishlist data:", error);
        });
    }
  }

  useEffect(() => {
    fetchWishlistData();
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 m-2">
      {wishlistData.map((college, index) => (
        <CollegeCard
          key={college.collegeId}
          collegeName={college.title}
          image={college.image}
          category={college.category}
          categoryId={college.collegeId}
          location={college.location || "location not available"}
          type={"shortlist"}
        />
      ))}
    </div>
  );
};

export default Shortlist;
